module.exports = __webpack_public_path__ + "img/finance_rekap.015019c2.svg";